import styled from 'styled-components';

export const OptionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '10rem',

  marginInlineStart: 'auto',
});

export const MenuOption = styled.button(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  gap: '10rem',
  padding: 0,

  backgroundColor: 'transparent',
  border: 'none',

  minHeight: '69rem',

  fontSize: theme.typography.size12,
  fontFamily: theme.typography.family.arial,
  color: theme.palette.erieBlack,

  cursor: 'pointer',

  transition: 'color 350ms linear, fill 350ms linear, stroke 350ms linear',

  '&[data-is-selected="true"]': {
    color: theme.palette.artichoke,
  },

  '&:hover': {
    color: theme.palette.artichoke,

    svg: {
      color: theme.palette.artichoke,
    },
  },

  svg: {
    transition: 'inherit',
  },
}));
